import React from "react";

const Loader = (props) => {
  return <div className="fixed top-0 left-0 bottom-0 right-0 bg-white bg-opacity-50 z-[100] ajax-loading"></div>
};

export default Loader;
